/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav ELD/DVIR Icon component.
 */
export const SideNavELDIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="4.41435" y1="12.5315" x2="8.41435" y2="7.53148" stroke={iconColor} strokeWidth="1.5"/>
      <line x1="17.4143" y1="9.53148" x2="21.4143" y2="4.53148" stroke={iconColor} strokeWidth="1.5"/>
      <line x1="14.2153" y1="9.82305" x2="11.2153" y2="6.82305" stroke={iconColor} strokeWidth="1.5"/>
      <circle cx="3.12677" cy="14.4754" r="2.12677" fill="none" stroke={iconColor} strokeWidth="1.5"/>
      <circle cx="9.93219" cy="5.82647" r="2.12677" fill="none" stroke={iconColor} strokeWidth="1.5"/>
      <circle cx="15.9583" cy="11.0015" r="2.12677" fill="none" stroke={iconColor} strokeWidth="1.5"/>
      <circle cx="22.8733" cy="3.12677" r="2.12677" fill="none" stroke={iconColor} strokeWidth="1.5"/>
    </svg>
  );
};
